export default "__VITE_ASSET__52aa92a0__"